import { NumberInput, Text } from "@instructure/ui";

const WrapperNumberInput = ({ id, label, value, setObject, fieldName }) => (
  <NumberInput
    id={id}
    renderLabel={<Text>{label}</Text>}
    onIncrement={() =>
      setObject((prev) => ({
        ...prev,
        [fieldName]: Number(prev[fieldName] || 0) + 1,
      }))
    }
    onDecrement={() =>
      setObject((prev) => ({
        ...prev,
        [fieldName]: Math.max(0, Number(prev[fieldName]) - 1) || "",
      }))
    }
    onChange={(e) => {
      setObject((prev) => ({
        ...prev,
        [fieldName]: Number(e.target.value.replace(/\D/g, "") || 0) || "",
      }));
    }}
    value={value || ""}
  />
);

export default WrapperNumberInput;
